import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

export const overwriteChronicDiseaseCounter = (
   medicalInformationCountByType: MedicalInformationCountByType[] | undefined,
   chronicDiseaseCount: number | undefined
): MedicalInformationCountByType[] | undefined => {
   if (!medicalInformationCountByType) {
      return undefined;
   }

   if (chronicDiseaseCount) {
      const chronicDiseaseCounterIndex = medicalInformationCountByType.findIndex(
         ({ type }) => type === 'CHRONIC_DISEASE'
      );

      if (chronicDiseaseCounterIndex !== -1) {
         medicalInformationCountByType[chronicDiseaseCounterIndex].medicalInformationCount = chronicDiseaseCount;
      }
   }

   return [...medicalInformationCountByType];
};
